import { render, staticRenderFns } from "./blog2.vue?vue&type=template&id=6a67b20e"
import script from "./blog2.vue?vue&type=script&lang=js"
export * from "./blog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports